/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AgentImpersonationExchangeResponseImpersonation from './AgentImpersonationExchangeResponseImpersonation';

/**
 * The AgentImpersonationExchangeResponse model module.
 * @module model/AgentImpersonationExchangeResponse
 * @version 1.0.0
 */
class AgentImpersonationExchangeResponse {
    /**
     * Constructs a new <code>AgentImpersonationExchangeResponse</code>.
     * @alias module:model/AgentImpersonationExchangeResponse
     */
    constructor() { 
        
        AgentImpersonationExchangeResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentImpersonationExchangeResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentImpersonationExchangeResponse} obj Optional instance to populate.
     * @return {module:model/AgentImpersonationExchangeResponse} The populated <code>AgentImpersonationExchangeResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentImpersonationExchangeResponse();

            if (data.hasOwnProperty('access_token')) {
                obj['access_token'] = ApiClient.convertToType(data['access_token'], 'String');
            }
            if (data.hasOwnProperty('expires_at')) {
                obj['expires_at'] = ApiClient.convertToType(data['expires_at'], 'Date');
            }
            if (data.hasOwnProperty('impersonation')) {
                obj['impersonation'] = AgentImpersonationExchangeResponseImpersonation.constructFromObject(data['impersonation']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentImpersonationExchangeResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentImpersonationExchangeResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['access_token'] && !(typeof data['access_token'] === 'string' || data['access_token'] instanceof String)) {
            throw new Error("Expected the field `access_token` to be a primitive type in the JSON string but got " + data['access_token']);
        }
        // validate the optional field `impersonation`
        if (data['impersonation']) { // data not null
          AgentImpersonationExchangeResponseImpersonation.validateJSON(data['impersonation']);
        }

        return true;
    }


}



/**
 * @member {String} access_token
 */
AgentImpersonationExchangeResponse.prototype['access_token'] = undefined;

/**
 * @member {Date} expires_at
 */
AgentImpersonationExchangeResponse.prototype['expires_at'] = undefined;

/**
 * @member {module:model/AgentImpersonationExchangeResponseImpersonation} impersonation
 */
AgentImpersonationExchangeResponse.prototype['impersonation'] = undefined;






export default AgentImpersonationExchangeResponse;

